import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelopeOpen, FaTwitter, FaFacebookF, FaInstagram, FaYoutube, FaWhatsapp, FaCircle } from "react-icons/fa";
import {  useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  return (
    <footer role="contentinfo">
      <div className="px-4 bg-[#00152f] text-light footer pt-2  wow fadeIn " data-wow-delay="0.1s">
        <div className="w-full pt-5 pb-2">
          <div className="flex max-lg:flex-col items-start justify-around gap-2">
            {/* Logo */}
            <div className="">
              <img
                src="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/bluelogo2_fk9fg1"
                alt="Shri Radhe Holidays"
                loading="lazy"
                title="Shri Radhe Holidays"
                className="h-auto w-[70%] sm:w-[40%] md:w-[70%] lg:w-[140px]  object-cover mb-4"
              />
              <p className="poppins max-md:text-[14px] lg:text-[12px] xl:text-[14px] text-[#D4AF37] mb-0 ">CIN : <span className="text-white">U52291DL2025PTC442627</span></p>
              <p className="poppins max-md:text-[14px] lg:text-[12px] xl:text-[14px] text-[#D4AF37]">GSTIN : <span className="text-white">07ABPCS2723K1ZY</span></p>

            </div>
            {/* Section 1 */}
            <div className="max-lg:mt-3 mt-2 ">
              <h1 className="text-[#D4AF37] max-md:text-[20px] md:text-[24px] lg:text-[16px] xl:text-[24px] mb-3 ml-4 max-lg:ml-0 playfair-display">Contacts</h1>

              <p className="mb-2 ml-4 max-lg:ml-0 flex items-center poppins text-white max-md:text-[14px] lg:text-[12px] xl:text-[14px]"><FaMapMarkerAlt className="mr-3 text-[#D4AF37]" />WB-82,Shakarpur,Laxmi Nagar,New Delhi</p>
              <a href="tel:9560070953" className="max-md:text-[14px] lg:text-[12px] xl:text-[14px] mb-2 ml-4 max-lg:ml-0 flex items-center no-underline cursor-pointer text-white  poppins"><FaPhoneAlt className="mr-3 text-[#D4AF37]" />+91 9560070953</a>
              <p className="max-md:text-[14px] lg:text-[12px] xl:text-[14px] mb-2 ml-4 max-lg:ml-0 flex items-center poppins text-white"><a href="mailto:shriradheholidayss@gmail.com?subject=Inquiry&body=Hello, I would like to know more about your services." className="no-underline cursor-pointer me-3 text-light flex justify-center items-center text-white"> <FaEnvelopeOpen className="mr-3 text-[#D4AF37]" />shriradheholidayss@gmail.com</a></p>

              <div className="flex justify-start "> {/* Container alignment adjust karein */}
                <a
                  href={`https://wa.me/919560070953?text=Hi,%20I%20want%20to%20plan%20my%20trip.%20Please%20help%20me%20with%20the%20best%20options.`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="no-underline "
                >
                  <button
                    type="submit"
                    className="
                                        relative z-10 overflow-hidden group flex items-center justify-start gap-2 
                                    rounded-r-full  shadow-xl isolation-auto transition-all duration-700
                                    
                                    /* Colors */
                                    bg-[#0B1C3D] text-[#ffffff] hover:text-gray-50
                                    
                                    /* Responsive Sizing (Mobile first) */
                                         px-3 py-2 text-[12px]           /* Default: Mobile */
                            sm:px-6 sm:py-3 sm:text-[12px] /* Tablets */
                            lg:px-8 lg:py-3 lg:text-[12px]   /* Desktop */
                            lg:font-semibold
                                    
                                    /* Hover Effect Logic */
                                    before:absolute before:w-full before:transition-all before:duration-700 
                                    before:-left-full before:hover:left-0 before:rounded-full before:bg-[#D4AF37] 
                                    before:-z-10 before:aspect-square before:hover:scale-150
                                    "
                  >
                    <FaWhatsapp className='text-xl  mr-0 ' />
                    <span className="whitespace-nowrap">Get My Quote on WhatsApp</span>
                    <svg
                      className="
                                        shrink-0 ease-linear duration-300 rounded-full border border-[#D4AF37] p-2 rotate-45
                                        
                                        /* Responsive Icon Size */
                                        w-6 h-6   /* Mobile */
                                        sm:w-7 sm:h-7 /* Tablet/Desktop */
                                        
                                        /* Hover States */
                                        group-hover:rotate-90 group-hover:bg-gray-50 group-hover:border-none
                                    "
                      viewBox="0 0 16 19"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7 18C7 18.5523 7.44772 19 8 19C8.55228 19 9 18.5523 9 18H7ZM8.70711 0.292893C8.31658 -0.0976311 7.68342 -0.0976311 7.29289 0.292893L0.928932 6.65685C0.538408 7.04738 0.538408 7.68054 0.928932 8.07107C1.31946 8.46159 1.95262 8.46159 2.34315 8.07107L8 2.41421L13.6569 8.07107C14.0474 8.46159 14.6805 8.46159 15.0711 8.07107C15.4616 7.68054 15.4616 7.04738 15.0711 6.65685L8.70711 0.292893ZM9 18L9 1H7L7 18H9Z"
                        className="fill-[#D4AF37]"
                      ></path>
                    </svg>
                  </button>
                </a>
              </div>
              {/* <a className="flex items-center text-white no-underline mb-1" href="/about"><FaCircle className="mr-1 w-1" /> About Us</a>
            <a className="flex items-center text-white no-underline mb-1" href="/contact"><FaCircle className="mr-1 w-1" />Contact Us</a>
            <a className="flex items-center text-white no-underline mb-1" href="/privacypolicy"><FaCircle className="mr-1 w-1" />Privacy Policy</a>
            <a className="flex items-center text-white no-underline mb-1" href="/termsconditions"><FaCircle className="mr-1 w-1" />Terms & Condition</a> */}
              {/* <!-- <a className="btn btn-link" href="/">FAQs & Help</a> --> */}
            </div>
            {/* Section 2 */}
            <div className="mt-2 max-lg:w-full">
              <h1 className="text-[#D4AF37] max-md:text-[20px] md:text-[24px] lg:text-[16px] xl:text-[24px] mb-3 playfair-display">Quick Links</h1>
              <div className="max-lg:flex max-lg:flex-wrap max-lg:justify-start gap-x-4 gap-y-2">
                <a className="max-md:text-[14px] lg:text-[12px] xl:text-[14px] flex items-center text-white no-underline mb-1 poppins" href="/"><FaCircle className="mr-2 w-2  text-[#D4AF37]" />Home</a>
                <a className="max-md:text-[14px] lg:text-[12px] xl:text-[14px] flex items-center text-white no-underline mb-1 poppins" href="/packages"><FaCircle className="mr-2 w-2  text-[#D4AF37]" />Holidays Packages</a>
                <a className="max-md:text-[14px] lg:text-[12px] xl:text-[14px] flex items-center text-white no-underline mb-1 poppins" href="/group-tour"><FaCircle className="mr-2 w-2  text-[#D4AF37]" />Group Tour</a>
                <a className="max-md:text-[14px] lg:text-[12px] xl:text-[14px] flex items-center text-white no-underline mb-1 poppins" href="/about"><FaCircle className="mr-2 w-2  text-[#D4AF37]" /> About Us</a>
                <a className="max-md:text-[14px] lg:text-[12px] xl:text-[14px] flex items-center text-white no-underline mb-1 poppins" href="/contact"><FaCircle className="mr-2 w-2  text-[#D4AF37]" />Contact Us</a>
              </div>
              {/* <a className="flex items-center text-white no-underline mb-1" href="/privacypolicy"><FaCircle className="mr-1 w-1" />Privacy Policy</a>
            <a className="flex items-center text-white no-underline mb-1" href="/termsconditions"><FaCircle className="mr-1 w-1" />Terms & Condition</a> */}

            </div>
            {/* Section 3 */}
            <div className="mt-2 max-lg:w-full">
              <h1 className="text-[#D4AF37] max-md:text-[20px] md:text-[24px] lg:text-[16px] xl:text-[24px] mb-3 playfair-display">Top Destinations</h1>
               <div className="max-lg:flex max-lg:flex-wrap max-lg:justify-start gap-x-4 gap-y-2">
                <a className="max-md:text-[14px] lg:text-[12px] xl:text-[14px] flex items-center text-white no-underline mb-1 poppins" href="/packages/thailand"><FaCircle className="mr-2 w-2  text-[#D4AF37]" />Thailand</a>
                <a className="max-md:text-[14px] lg:text-[12px] xl:text-[14px] flex items-center text-white no-underline mb-1 poppins" href="/packages/dubai"><FaCircle className="mr-2 w-2  text-[#D4AF37]" />Dubai</a>
                <a className="max-md:text-[14px] lg:text-[12px] xl:text-[14px] flex items-center text-white no-underline mb-1 poppins" href="/packages/bali"><FaCircle className="mr-2 w-2  text-[#D4AF37]" />Bali</a>
                <a className="max-md:text-[14px] lg:text-[12px] xl:text-[14px] flex items-center text-white no-underline mb-1 poppins" href="/packages/vietnam"><FaCircle className="mr-2 w-2  text-[#D4AF37]" />Vietnam</a>
                <a className="max-md:text-[14px] lg:text-[12px] xl:text-[14px] flex items-center text-white no-underline mb-1 poppins" href="/packages/maldives"><FaCircle className="mr-2 w-2  text-[#D4AF37]" />Maldives</a>
                <a className="max-md:text-[14px] lg:text-[12px] xl:text-[14px] flex items-center text-white no-underline mb-1 poppins" href="/packages/singapore"><FaCircle className="mr-2 w-2  text-[#D4AF37]" />Singapore</a>
                <a className="max-md:text-[14px] lg:text-[12px] xl:text-[14px] flex items-center text-white no-underline mb-1 poppins" href="/packages/malaysia"><FaCircle className="mr-2 w-2  text-[#D4AF37]" />Malyasia</a>
              </div>
              {/* <a className="flex items-center text-white no-underline mb-1" href="/privacypolicy"><FaCircle className="mr-1 w-1" />Privacy Policy</a>
            <a className="flex items-center text-white no-underline mb-1" href="/termsconditions"><FaCircle className="mr-1 w-1" />Terms & Condition</a> */}

            </div>
            {/* Section 4 */}
            <div className="my-2 ">
              <h1 className="text-[#D4AF37] max-md:text-[20px] md:text-[24px] lg:text-[16px] xl:text-[24px] mb-3  playfair-display">Join Our Travel Deals Community</h1>
              <p className="poppins  text-white max-md:text-md mb-2 lg:text-[12px] xl:text-[14px]">Get latest offers & deals directly on WhatsApp</p>
              <div className="flex justify-start mr-1"> {/* Container alignment adjust karein */}
                <a
                  href="https://chat.whatsapp.com/GLcWoDBPKSD0OBcwikqtRe"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="no-underline "
                >
                  <button
                    type="submit"
                    className="
                                                    relative z-10 overflow-hidden group flex items-center justify-center gap-2 
                                                rounded-r-full  shadow-xl isolation-auto transition-all duration-700
                                                
                                                /* Colors */
                                                bg-[#ffffff] text-[#0B1C3D] hover:text-white
                                                
                                                /* Responsive Sizing (Mobile first) */
                                                px-3 py-2 text-[14px]           /* Default: Mobile */
                            sm:px-6 sm:py-3 sm:text-[14px] /* Tablets */
                            lg:px-8 lg:py-3 lg:text-[14px]   /* Desktop */
                            lg:font-semibold
                                                
                                                                              /* Hover Effect Logic */
                                                before:absolute before:w-full before:transition-all before:duration-700 
                                                before:-left-full before:hover:left-0 before:rounded-full before:bg-[#41c051] 
                                                before:-z-10 before:aspect-square before:hover:scale-150
                  "
                  >
                    <FaWhatsapp className='text-xl mr-0' />
                    <span className="whitespace-nowrap ">Join Now</span>
                    <svg
                      className="
                                                        shrink-0 ease-linear duration-300 rounded-full border-1 border-[#0B1C3D] p-2 rotate-45
                                                        
                                                        /* Responsive Icon Size */
                                                        w-6 h-6   /* Mobile */
                                                        sm:w-7 sm:h-7 /* Tablet/Desktop */
                                                        
                                                        /* Hover States */
                                                        group-hover:rotate-90 group-hover:bg-[#ffffff] group-hover:border-none
                                                    "
                      viewBox="0 0 16 19"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7 18C7 18.5523 7.44772 19 8 19C8.55228 19 9 18.5523 9 18H7ZM8.70711 0.292893C8.31658 -0.0976311 7.68342 -0.0976311 7.29289 0.292893L0.928932 6.65685C0.538408 7.04738 0.538408 7.68054 0.928932 8.07107C1.31946 8.46159 1.95262 8.46159 2.34315 8.07107L8 2.41421L13.6569 8.07107C14.0474 8.46159 14.6805 8.46159 15.0711 8.07107C15.4616 7.68054 15.4616 7.04738 15.0711 6.65685L8.70711 0.292893ZM9 18L9 1H7L7 18H9Z"
                        className="fill-[#0B1C3D]"
                      ></path>
                    </svg>
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
        {/* Bottom Section 5 */}
        <div className="w-full">
          <div className="copyright">
            <div className="flex max-lg:flex-col max-lg:items-start items-center justify-between px-[5px]">
              <div className="max-lg:mb-4">
                &copy; <a className="font-bold no-underline playfair-display max-md:text-[14px] lg:text-[12px] xl:text-[16px] " href="/">2026 ShriRadheHolidays.com All rights reserved.</a>
              </div>
              <div className="flex max-lg:mb-4 ">
                {/* Twitter */}
                <a
                  className="flex items-center justify-center mx-1 max-lg:w-7 max-lg:h-7 lg:w-7 lg:h-7 xl:w-9 xl:h-9 rounded-full border border-white text-white transition duration-300 hover:bg-[#1DA1F2] hover:border-[#1DA1F2]"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://x.com/ShRadheHolidays"
                  aria-label="Follow us on Twitter"
                >
                  <FaTwitter className="max-md:text-[14px] lg:text-[16px] xl:text-[18px]" />
                </a>

                {/* Facebook */}
                <a
                  className="flex items-center justify-center mx-1 max-lg:w-7 max-lg:h-7 lg:w-7 lg:h-7 xl:w-9 xl:h-9 rounded-full border border-white text-white transition duration-300 hover:bg-[#1877F2] hover:border-[#1877F2]"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.facebook.com/profile.php?id=61573011625834"
                  aria-label="Like us on Facebook"
                >
                  <FaFacebookF className="max-md:text-[14px] lg:text-[16px] xl:text-[18px]" />
                </a>

                {/* Instagram */}
                <a
                  className="flex items-center justify-center mx-1 max-lg:w-7 max-lg:h-7 lg:w-7 lg:h-7 xl:w-9 xl:h-9 rounded-full border border-white text-white transition duration-300 hover:bg-gradient-to-r hover:from-pink-500 hover:via-red-500 hover:to-yellow-500"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.instagram.com/shriradheholidays/"
                  aria-label="Follow us on Instagram"
                >
                  <FaInstagram className="max-md:text-[14px] lg:text-[16px] xl:text-[18px]" />
                </a>

                {/* YouTube */}
                <a
                  className="flex items-center justify-center mx-1 max-lg:w-7 max-lg:h-7 lg:w-7 lg:h-7 xl:w-9 xl:h-9 rounded-full border border-white text-white transition duration-300 hover:bg-[#FF0000] hover:border-[#FF0000]"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.youtube.com/@ShriRadheHolidays"
                  aria-label="Subscribe to our YouTube channel"
                >
                  <FaYoutube className="max-md:text-[14px] lg:text-[16px] xl:text-[18px]" />
                </a>
              </div>
              <div className="text-start">
                <div className="flex footer-menu max-md:text-[14px] lg:text-[12px] xl:text-[16px]  poppins">
                  <div className="cursor-pointer" onClick={() => navigate("/")}>Home</div >
                  <div className="cursor-pointer" onClick={() => navigate("/cookiesPolicy")}>Cookies</div >
                  <div className="cursor-pointer" onClick={() => navigate("/help")}>Help</div >
                  <div className="cursor-pointer" onClick={() => navigate("/privacypolicy")}>Privacy Policy</div >
                  <div className="cursor-pointer" onClick={() => navigate("/termsconditions")}>Terms & Condition</div >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
